import { Typography, Space, Button } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';

import { PointInTime } from '~components/PointInTime';
import RenderedHtml from './RenderedHtml';

/**
 * @param {Object} props
 * @param {Object} props.notification
 * @param {String} props.notification.description
 * @param {String} props.notification.createdAt - ISO date string
 * @param {Object} props.notification.metadata
 * @param {String=} props.notification.metadata.htmlContent - HTML content
 * @param {String=} props.notification.metadata.downloadURL - URL
 */
function PageReportNotification({ notification }) {
  const { metadata = {} } = notification;

  return (
    <Space direction="vertical" size="large">
      <Typography.Text strong>
        <PointInTime value={notification.createdAt} />
      </Typography.Text>
      <Typography.Title type="success" level={4}>
        <PaperClipOutlined /> New page report available
      </Typography.Title>
      <Typography.Title level={3}>{notification.description}</Typography.Title>

      <RenderedHtml html={metadata.htmlContent} />

      <Button download href={metadata.downloadURL} type="primary">
        Download Here
      </Button>
    </Space>
  );
}

export default PageReportNotification;
